<template lang="html">
    <v-content>
      <img
      id = "display-logo"
      src="../assets/login-logo-nicechat.png"
      contain
      width="100"
      height="100"
      >
      <div id = "display-logo-text">NiceChat</div>
  <div id="firebaseui-auth-container"></div>
  <div id="my-signin2"></div>
  </v-content>
</template>

<script>
// import firebase from 'firebase/app';
import {firebase} from '@/plugins/firebase.js';
import firebaseui from 'firebaseui';
import {app_url} from '@/plugins/projectvars.js'; 

export default {
  name: 'auth',
  mounted() {
    //this.glogininit();
    var ui = new firebaseui.auth.AuthUI(firebase.auth());
    ui.start('#firebaseui-auth-container', {
        signInSuccessUrl: app_url,
        signInOptions: [
          {
           provider: firebase.auth.FacebookAuthProvider.PROVIDER_ID,
           scopes: [
              'pages_messaging','email'
            ],
          }
        ],
          // Terms of service url.
            tosUrl: 'https://nicechat.in/terms-of-use/',
            // Privacy policy url.
            privacyPolicyUrl: 'https://nicechat.in/privacy-policy/'
            // Other config options...
    });
    //this.renderButton()
  },
  methods:{
    // glogininit(){
    //   var gapi=window.gapi
    //   gapi.load('auth2', function() {
    //     console.log("google login initiated")
    //     let auth2 = gapi.auth2.init({
    //       client_id: '753213076159-atp20v961as5hu2ldobi8qfcaodiv986.apps.googleusercontent.com',
    //       // Scopes to request in addition to 'profile' and 'email'
    //       scope: 'profile email'
    //     });
    //   });
      
    // },
    // renderButton() {
    //   console.log("Hello")
    //   gapi.signin2.render('my-signin2', {
    //     'scope': 'profile email',
    //     'width': 240,
    //     'height': 50,
    //     'longtitle': true,
    //     'theme': 'dark',
    //      'onsuccess': onSuccess,
    //      'onfailure': onFailure
    //   });
    // }
  }

}
</script>

<style>
    #firebaseui-auth-container{
        margin-top: 250px       
    }
    #display-logo{
      position: absolute;
      top: 25%;
      left: 50%;
      transform: translate(-50%, -50%) 
    }
    #display-logo-text{
      position: absolute;
      top: 35%;
      left: 50%;
      color:#448AFF;
      transform: translate(-50%, -50%) 
    }
</style>
